import { createContext, useContext } from 'react';

// Create the Context object
export const ConfigContext = createContext(null);

// Create the Hook
export const useConfig = () => {
    const context = useContext(ConfigContext);
    if (!context) {
        throw new Error('useConfig must be used within a ConfigProvider');
    }
    return context;
};
